import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TypeColorIcon, IVehicleIcon, IUserVehicleIcon, ItemIcon, TypeIcon, Direction } from '../models/interfaces';


import { getDataTransmissionStates } from 'src/app/units/helpers/unit-helper';

interface TransmissionStatusColor {
  color: string,
  status: string
}
interface StateColors {
  [status: string]: SafeUrl; // Permite cualquier string como clave, con valores string
}


@Injectable({
  providedIn: 'root'
})
export class UserIconsService {

  private fileRoot = "./assets/images/objects/nuevo/default/"

  private colors = {
    default: 'c4c2c1',
    excess: 'FB472A',
    relenti: '0396F6',
    movement: '04DE04'
  };
  changeItemIcon: ItemIcon = ItemIcon.NULL; // item para cambiar colores
  stateVehiclesDirectionSvg: boolean = false;
  stateCustomDirectionSvg: boolean = false;
  changeRotateIcon: boolean = false; // rotacion

  vehicles: IVehicleIcon[] = []
  userVehicles: IUserVehicleIcon[] = []
  transmissionStatusColor: TransmissionStatusColor[] = []
  constructor(
    private sanitizer: DomSanitizer,
  ) {
    this.transmissionStatusColor = getDataTransmissionStates().map(tr => {
      return {
        color: tr.transmissionStatusColor.substring(1),
        status: tr.transmissionStatusId.toString()
      }
    });
    console.log("user icons : color transmision", this.transmissionStatusColor)
  }

  public async initializeVehicles(
    vehicles: IVehicleIcon[],
    userVehicles: IUserVehicleIcon[],
    itemIcon: ItemIcon,
    direction: boolean = false
  ) {
    this.vehicles = vehicles;
    console.log(vehicles, "iconos antes")
    this.userVehicles = userVehicles
    this.changeItemIcon = itemIcon
    this.changeRotateIcon = direction
    await this.setTypeVehicles()
    console.log(vehicles, "iconos despues")
    this.clearAllSvgCache();
  }

  private getDirection(directionssvg: any, direction: string): string {
    const directionsMap: { [key: string]: string } = {
      'upleft': directionssvg.UpLeft,
      'downleft': directionssvg.DownLeft,
      'left': directionssvg.Left,
      'right': directionssvg.Right,
      'upright': directionssvg.UpRight,
      'downright': directionssvg.DownRight,
    };
    return directionsMap[direction] || directionssvg.DownLeft;
  }
  private async setTypeVehicles(): Promise<void> {
    try {
      for (const vehicle of this.vehicles) {
        await this.processSingleVehicle(vehicle);
      }
    } catch (error) {
      console.error("iconsService : error", error);
    }
    console.log("iconsService : icon", this.vehicles);
    console.log("iconsService : user icon", this.userVehicles);
  }

  private async processSingleVehicle(vehicle: any): Promise<void> {
    const vehicleFound = this.findUserIconById(vehicle.id);

    // Configurar icono y URL base
    if (vehicleFound) {
      vehicle.customurl = `${this.fileRoot}${vehicleFound.var_icono}`;
      vehicle.var_icono = vehicleFound.var_icono;
    } else {
      vehicle.customurl = `${this.fileRoot}${vehicle.var_icono}`;
      // vehicle.var_icono queda igual
    }

    const colorHex = vehicleFound ? vehicleFound.var_color : TypeColorIcon.Default;
    vehicle.icon_url = `backup/${colorHex}/${vehicle.var_icono}`;

    // Generar SVG coloreado principal
    vehicle.customsvg = (await this.setColorSvgPath(colorHex, vehicle.customurl)) || "";
    vehicle.customSanitizerSvg = this.sanitizer.bypassSecurityTrustUrl(vehicle.customsvg);

    // Si corresponde, generar los estados de transmisión con colores
    if (this.changeItemIcon === ItemIcon.VEHICLES) {
      vehicle.transmissionStatus = await this.generateTransmissionStateColors(vehicle.customurl);

      if (this.canChangeIconDirection()) {
        vehicle.transmissionIconsByDirection = await this.generateTransmissionDirectionIcons(vehicle.customurl);
        this.stateVehiclesDirectionSvg = true;
      }
    }

    // Generar SVG con dirección personalizada si aplica
    if (this.canChangeIconDirection()) {
      vehicle.customDirectionSvg = await this.generateDirectionSvg(colorHex, vehicle.customurl);
      this.stateCustomDirectionSvg = Boolean(vehicle.customDirectionSvg);
    }
  }

  private async generateTransmissionStateColors(customurl: string): Promise<StateColors> {
    const stateColors: StateColors = {};
    const promises = this.transmissionStatusColor.map(async (transmision) => {
      stateColors[transmision.status] = (await this.setColorSvgPath(transmision.color, customurl)) || "";
    });
    await Promise.all(promises);
    return stateColors;
  }

  private async generateTransmissionDirectionIcons(customurl: string): Promise<Record<string, string>> {
    const stateColorDirections: Record<string, string> = {};
    const promises = this.transmissionStatusColor.map(async (transmision) => {
      stateColorDirections[transmision.status] = (await this.generateDirectionSvg(transmision.color, customurl)) || "";
    });
    await Promise.all(promises);
    return stateColorDirections;
  }

  private svgCache = new Map<string, string>(); // clave: svgPath, valor: contenido SVG
  private async setColorSvgPath(colorHex: string, svgPath: string, flipDirection: boolean = false): Promise<SafeUrl | undefined> {
    try {
      let svgCode: string;
      if (this.svgCache.has(svgPath)) {
        svgCode = this.svgCache.get(svgPath)!;
      } else {
        svgCode = await (await fetch(svgPath)).text();
        this.svgCache.set(svgPath, svgCode); // 🧠 Guardar en caché
      }

      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgCode, 'image/svg+xml');
      const styleElement = svgDoc.querySelector('style');

      if (!styleElement) {
        throw new Error("Elemento <style> no encontrado en el SVG");
      }

      // 🎨 Reemplazar el color
      let styleContent = styleElement.innerHTML;

      // Intentar reemplazar el fill de `.cls-14`
      let updated = false;

      styleContent = styleContent.replace(/\.cls-14\s*\{[^}]*\}/, (match) => {
        updated = true;
        return match.replace(/fill\s*:\s*#[^;]*/, `fill: #${colorHex}`);
      });

      // Si no se actualizó `.cls-14`, intentar con `.body`
      if (!updated) {
        styleContent = styleContent.replace(/\.body\s*\{[^}]*\}/, (match) =>
          match.replace(/fill\s*:\s*#[^;]*/, `fill: #${colorHex}`)
        );
      }

      styleElement.innerHTML = styleContent;

      const svgElement = svgDoc.documentElement;

      // 🔄 Flip horizontal
      if (flipDirection) {
        svgElement.setAttribute('style', 'transform: scaleX(-1);');
      }

      const svgContent = svgElement.outerHTML;
      const urlParse = this.createSvgUrl(svgContent);

      return urlParse as any;
    } catch (error) {
      console.error('Error al procesar SVG:', error);
      return undefined;
    }
  }
  public clearAllSvgCache(): void {
    this.svgCache.clear();
  }
  private async generateDirectionSvg(color: string, url: string): Promise<any> {
    var urlDirectionUpLeft = url.replace('default/', 'default/upleft/');
    var urlDirectionDownLeft = url.replace('default/', 'default/downleft/');
    var urlDirectionLeft = url.replace('default/', 'default/left/');
    //var urlDirectionRight = url.replace('default/','default/right/');
    // var urlDirectionUpRight = url.replace('default/','default/upright/');
    //var urlDirectionDownRight = url.replace('default/','default/downright/');
    return {
      Left: await this.setColorSvgPath(color, urlDirectionLeft),
      Right: await this.setColorSvgPath(color, urlDirectionLeft, true),
      UpLeft: await this.setColorSvgPath(color, urlDirectionUpLeft),
      UpRight: await this.setColorSvgPath(color, urlDirectionUpLeft, true),
      DownLeft: await this.setColorSvgPath(color, urlDirectionDownLeft),
      DownRight: await this.setColorSvgPath(color, urlDirectionDownLeft, true),
    }
  }
  private findVehicleIcon(type: string): IVehicleIcon {
    const vehicle = this.vehicles.find((vehicle) => vehicle.var_icono == type)
    if (vehicle) { return vehicle }
    return this.vehicles[0]
  }
  public async getIconSpecific(
    type: TypeIcon,
    direction: Direction = Direction.DOWNRIGHT,
    color: TypeColorIcon = TypeColorIcon.Default,
    sanitizer: boolean = false
  ): Promise<any | undefined> {

    let flipDirection = false;
    const foundVehicleIcon = this.findVehicleIcon(type);

    const directionMap: { [key: string]: Direction } = {
      [Direction.UPRIGHT]: Direction.UPLEFT,
      [Direction.DOWNRIGHT]: Direction.DOWNLEFT,
      [Direction.RIGHT]: Direction.LEFT
    };

    // Ajusta la dirección
    if (directionMap[direction]) {
      direction = directionMap[direction];
      flipDirection = true;
      console.log(`iconsService: Dirección ajustada a: ${direction}, flipDirection: ${flipDirection}`);
    } else {
      console.log(`iconsService: Dirección no ajustada, usando la dirección original: ${direction}`);
    }

    // Función para obtener el SVG dependiendo del color
    const getColorSvg = (color: TypeColorIcon) => {
      console.log(`iconsService: Determinando el SVG para el color: ${color}`);
      switch (color) {
        case TypeColorIcon.Excess:
          console.log("iconsService: Usando color Excess");
          return foundVehicleIcon.excessDirectionSvg[direction] || foundVehicleIcon.excess_svg;
        case TypeColorIcon.Movement:
          console.log("iconsService: Usando color Movement");
          return foundVehicleIcon.movementDirectionSvg[direction] || foundVehicleIcon.movement_svg;
        case TypeColorIcon.Relenti:
          console.log("iconsService: Usando color Relenti");
          return foundVehicleIcon.relentiDirectionSvg[direction] || foundVehicleIcon.relenti_svg;
        case TypeColorIcon.Default:
        default:
          console.log("iconsService: Usando color Default");
          return foundVehicleIcon.customDirectionSvg[direction] || foundVehicleIcon.customsvg;
      }
    };

    // Obtén el SVG de color según la lógica existente
    let svg = '';
    if (this.isVehicleIconChange()) {
      console.log("iconsService: Se detectó un cambio en el icono del vehículo.");
      if (this.canChangeIconDirection()) {
        console.log("iconsService: Se puede cambiar la dirección del icono, devolviendo SVG de color.");
        svg = getColorSvg(color);
      } else {
        console.log("iconsService: No se puede cambiar la dirección del icono, devolviendo SVG de color.");
        svg = getColorSvg(color);
      }
    } else {
      console.log("iconsService: No se detectó un cambio en el icono del vehículo.");
      if (this.canChangeIconDirection()) {
        console.log("iconsService: Se puede cambiar la dirección del icono, devolviendo SVG de dirección personalizada.");
        svg = foundVehicleIcon.customDirectionSvg[direction];
      } else {
        console.log("iconsService: No se puede cambiar la dirección del icono, devolviendo el SVG personalizado por defecto.");
        svg = foundVehicleIcon.customsvg;
      }
    }

    // Si sanitizer es true, sanitiza la URL
    if (sanitizer) {
      console.log("iconsService: Sanitizando la URL del SVG");
      return svg; // Sanitiza la URL antes de devolverla
    }

    return svg; // Devolver el SVG normal si sanitizer es false
  }


  private canChangeIconDirection(): boolean {
    return this.changeRotateIcon;
  }
  private isVehicleIconChange(): boolean {
    return this.changeItemIcon == ItemIcon.VEHICLES
  }
  public async getSanitizerSVG(id: number | string): Promise<any> {
    if (typeof id === 'string') {
      id = parseInt(id);
    }
    const svg = this.findIconById(id)
    return svg?.customSanitizerSvg
  }
  public getDirectionSvg(type: string, state: string, direction?: string): any {
    const typeConfigVehicle = this.findIconById(parseInt(type));

    if (!typeConfigVehicle) { return; }

    const stateConfig: any = {
      'default': typeConfigVehicle.customsvg,
      'excess': typeConfigVehicle.excess_svg,
      'movement': typeConfigVehicle.movement_svg,
      'relenti': typeConfigVehicle.relenti_svg,
    };

    const directionStateConfig: any = {
      'default': typeConfigVehicle.customDirectionSvg, // objeto de todas 6 direcciones del icono
      'excess': typeConfigVehicle.excessDirectionSvg,
      'movement': typeConfigVehicle.movementDirectionSvg,
      'relenti': typeConfigVehicle.relentiDirectionSvg,
    };

    if (!direction) {
      return stateConfig[state] || null;
    } else {
      const svgPath = directionStateConfig[state];
      return svgPath ? this.getDirection(svgPath, direction) : null;
    }
  }
  public findIconById(id: number): IVehicleIcon | undefined {
    return this.vehicles.find((vehicle) => vehicle.id === id);
  }
  public getIconTransmission(vehicleId: number, transmissionId: string) {
    if (vehicleId && transmissionId) {
      const vehicleIcon = this.vehicles.find((vehicle) => vehicle.id === vehicleId);
      if (vehicleIcon) {
        if (vehicleIcon.transmissionStatus && vehicleIcon.transmissionStatus[transmissionId]) {
          return this.sanitizer.bypassSecurityTrustUrl(vehicleIcon.transmissionStatus[transmissionId] || "") || "";
        } else {
          return this.sanitizer.bypassSecurityTrustUrl(vehicleIcon.customsvg)
        }
      }
    }
    return "";
  }
  public getTransmissionIconUnsafe(vehicleId: number, transmissionId: string) {
    const vehicle = this.vehicles.find((v) => v.id === vehicleId);
    if (vehicle) {
      if (vehicle.transmissionStatus && transmissionId in vehicle.transmissionStatus) {
        return vehicle.transmissionStatus[transmissionId];
      }
      return vehicle.customsvg
    }
    return undefined
  }
  public getIconTransmissionDirection(
    vehicleId: number,
    transmissionId: string,
    direction: string
  ): SafeUrl | undefined {
    if (!vehicleId || !transmissionId) return undefined;

    const vehicle = this.vehicles.find(v => v?.id === vehicleId);
    direction = this.mapDirection(direction)

    if (!vehicle) return undefined;
    
    const directionIcon = vehicle.transmissionIconsByDirection?.[transmissionId]?.[direction];
    const customIcon = vehicle.customDirectionSvg?.[direction];

    const icon = directionIcon || customIcon;
    return icon ? this.sanitizer.bypassSecurityTrustUrl(icon) : undefined;
  }
  public getTransmissionIconDirectionUnsafe(vehicleId: number, transmissionId: string, direction: string) {
    if (!vehicleId || !transmissionId) return undefined;
    direction = this.mapDirection(direction)
    const vehicle = this.vehicles.find(v => v?.id === vehicleId);
    return vehicle?.transmissionIconsByDirection?.[transmissionId]?.[direction]
      || vehicle?.customDirectionSvg?.[direction];
  }

  public findUserIconById(id: number): IUserVehicleIcon | undefined {
    return this.userVehicles.find((vehicle) => vehicle.type_vehicle_id === id);
  }
  private createSvgUrl(svgContent: string): string {
    const blob = new Blob([svgContent], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    return url;
  }


  public async getDirectionSvgDeprecate(type: string, state: string, direction?: string): Promise<any> {
    const typeConfigVehicle = this.findIconById(parseInt(type))

    if (!typeConfigVehicle) { return; }

    if (!direction) {
      return state === 'default' ? typeConfigVehicle.customsvg :
        state === 'excess' ? typeConfigVehicle.excess_svg :
          state === 'movement' ? typeConfigVehicle.movement_svg :
            state === 'relenti' ? typeConfigVehicle.relenti_svg :
              null; // Otra acción por defecto si ninguno de los estados coincide
    } else {
      return state === 'default' ? this.getDirection(typeConfigVehicle.customDirectionSvg, direction) :
        state === 'excess' ? this.getDirection(typeConfigVehicle.excessDirectionSvg, direction) :
          state === 'movement' ? this.getDirection(typeConfigVehicle.movementDirectionSvg, direction) :
            state === 'relenti' ? this.getDirection(typeConfigVehicle.relentiDirectionSvg, direction) :
              null; // Otra acción por defecto si ninguno de los estados coincide
    }
  }
  public mapDirection(direction: string): Direction {
    const directionsMap: { [key: string]: Direction } = {
      'upleft': Direction.UPLEFT,
      'downleft': Direction.DOWNLEFT,
      'left': Direction.LEFT,
      'right': Direction.RIGHT,
      'upright': Direction.UPRIGHT,
      'downright': Direction.DOWNRIGHT,
    };

    return directionsMap[direction] || Direction.UPRIGHT;
  }
}
